module.exports = __webpack_public_path__ + "static/media/termopary2ru.a7e5d958.pdf";